"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ALERTS_NOTIFICATIONS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.ALERTS_NOTIFICATIONS;
  }
});
Object.defineProperty(exports, "APPOINTMENT_SCHEDULING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.APPOINTMENT_SCHEDULING;
  }
});
Object.defineProperty(exports, "AUTOMATED_SCHEDULING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.AUTOMATED_SCHEDULING;
  }
});
Object.defineProperty(exports, "CALENDAR_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CALENDAR_MANAGEMENT;
  }
});
Object.defineProperty(exports, "CUSTOMER_SCHEDULING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CUSTOMER_SCHEDULING;
  }
});
Object.defineProperty(exports, "DEAL_MANAGEMENT_PROMOTIONS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.DEAL_MANAGEMENT_PROMOTIONS;
  }
});
Object.defineProperty(exports, "EMPLOYEE_SCHEDULING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.EMPLOYEE_SCHEDULING;
  }
});
Object.defineProperty(exports, "FACILITY_SCHEDULING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.FACILITY_SCHEDULING;
  }
});
Object.defineProperty(exports, "GROUP_SCHEDULING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.GROUP_SCHEDULING;
  }
});
Object.defineProperty(exports, "MULTI_LOCATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.MULTI_LOCATION;
  }
});
Object.defineProperty(exports, "ONLINE_BOOKING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.ONLINE_BOOKING;
  }
});
Object.defineProperty(exports, "ONLINE_PAYMENT_ACCEPTANCE", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.ONLINE_PAYMENT_ACCEPTANCE;
  }
});
Object.defineProperty(exports, "REAL_TIME_SCHEDULING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.REAL_TIME_SCHEDULING;
  }
});
Object.defineProperty(exports, "RESOURCE_SCHEDULING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.RESOURCE_SCHEDULING;
  }
});
Object.defineProperty(exports, "ROOM_BOOKING_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.ROOM_BOOKING_MANAGEMENT;
  }
});

var _CategoryFeature = require("../CategoryFeature");


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/groupTags/categoryFeatures/Scheduling.js
// module id = 580
// module chunks = 209 210 211 212 213